import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/snail/three/reports/init', method: 'GET', params }, { interceptResultCode: false });
};
// 领取奖励
export const reward = (params) => {
  return axios({ url: '/snail/three/reports/reward', method: 'POST', params }, { interceptResultCode: false });
};
// 免密登录
export const secretFreeLoginApi = (data) => {
  return axios({ url: '/cherry/auth/login', method: 'POST', data }, { interceptResultCode: false });
};


// 绑定用户
export const bindUser = data => {
  return axios(
    { url: "/sea/login", method: "POST", data },
    { interceptResultCode: false } // 登录接口提示语是泰文，所以需要自己onToast
  );
};

// 注销用户
export const unsubscribe = data => {
  return axios({ url: "/sea/logout", method: "POST", data });
};


// WEBPACK FOOTER //
// ./src/pages/snail/5thReport/api.js